import { OverlayPanel } from './OverlayPanel';
import { SidebarPanel } from './SidebarPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export function CollapsiblePanel(props) {
  if (props.mode === 'overlay') {
    return /*#__PURE__*/_jsx(OverlayPanel, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(SidebarPanel, Object.assign({}, props));
}